import React from 'react';
import { Button } from 'new/elements/Button';
import { Stack } from 'new/elements/Stack';

interface ReingestButtonGroupProps {
  size: number;
  onCancel: () => void;
  onConfirm: () => void;
  isMultipleReingestActive: boolean;
  disabled?: boolean;
}

const getButtonText = (size = 0, multipleReingestActive = false): string => {
  if (multipleReingestActive) {
    return size === 1 ? `Re-Ingest ${size} File` : `Re-Ingest ${size} Files`;
  }
  return 'Re-Ingest Multiple Files';
};

const ReingestButtonGroup: React.FC<ReingestButtonGroupProps> = ({
  size = 0,
  onCancel,
  onConfirm,
  isMultipleReingestActive = false,
  disabled = false,
}) => {
  if (typeof onConfirm !== 'function') {
    console.error('ReingestButtonGroup: onConfirm must be a function');
    return null;
  }

  if (typeof onCancel !== 'function') {
    console.error('ReingestButtonGroup: onCancel must be a function ');
    return null;
  }

  return (
    <Stack direction="row" gap={1}>
      <Button color="primary" variant="outlined" disabled={disabled} onClick={onConfirm}>
        {getButtonText(size, isMultipleReingestActive)}
      </Button>
      {isMultipleReingestActive ? (
        <Button color="primary" variant="text" onClick={onCancel}>
          Cancel
        </Button>
      ) : null}
    </Stack>
  );
};

export { ReingestButtonGroup };
